import { baseApi } from './baseApi';
import { AUTH_TOKEN_STORAGE_KEY, setSessionAuthToken } from '../utils/authFetch';
import {
  LOGIN_HEADER_TOKEN_FIELD,
  extractPersistableLoginToken,
  readAuthTokenFromResponseHeaders,
} from '../utils/loginToken';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => ({
        url: '/api/login',
        method: 'POST',
        body,
      }),
      /** Backend may also return JWT on the response `Authorization` header; `unwrap()` is JSON-only. */
      transformResponse: (response, meta) => {
        const fromHeader = readAuthTokenFromResponseHeaders(meta?.response);
        if (!fromHeader) return response;
        if (response && typeof response === 'object' && !Array.isArray(response)) {
          return { ...response, [LOGIN_HEADER_TOKEN_FIELD]: fromHeader };
        }
        return response;
      },
      /** Persist token as soon as the mutation succeeds so the next RTK requests include the `token` header. */
      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          const fulfilled = await queryFulfilled;
          const payload = fulfilled?.data ?? fulfilled;
          const token =
            (typeof payload?.token === 'string' && payload.token.trim()) ||
            extractPersistableLoginToken(payload);
          if (token) {
            setSessionAuthToken(token);
            try {
              localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
            } catch {
              /* ignore quota / private mode */
            }
          }
        } catch {
          /* login failed */
        }
      },
    }),
  }),
});

export const { useLoginMutation } = authApi;

